import { Controller } from "@hotwired/stimulus"

// Stimulus controller pour le formulaire d'estimation immobilière
// Gère l'affichage conditionnel du champ terrain selon le type de bien
export default class extends Controller {
  static targets = ["typeBien", "terrainField"]

  connect() {
    // Initialiser l'état du champ terrain au chargement
    this.toggleTerrain()
  }

  // Affiche ou masque le champ surface terrain selon le type de bien
  toggleTerrain() {
    if (!this.hasTypeBienTarget || !this.hasTerrainFieldTarget) return

    const typeBien = this.typeBienTarget.value

    if (typeBien === "Maison") {
      this.terrainFieldTarget.classList.remove("hidden")
    } else {
      this.terrainFieldTarget.classList.add("hidden")
      // Optionnel: vider le champ terrain si appartement
      const terrainInput = this.terrainFieldTarget.querySelector("input")
      if (terrainInput) {
        terrainInput.value = ""
      }
    }
  }
}
